<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />

    <MainTabBar v-show="isMainTabBarShow" />
  </div>
</template>

<script>
import MainTabBar from "@/components/MainTabBar";
export default {
  name: "App",
  data() {
    return {
      isMainTabBarShow: true,
    };
  },
  watch: {
    $route(next) {
      console.log("next:",next);
      const { query } = next || {}
      const {hide}  = query || {} 
      if (['/login','/formPage','/phoneCodeLogin'].includes(next.path) || hide === 'true') {
        this.isMainTabBarShow = false;
      } else {
        this.isMainTabBarShow = true;
      }
    },
  },
  components: {
    MainTabBar,
  },
  methods: {},
  created() {},
};
</script>

<style lang="scss">
@use "./assets/style/base.scss" as *;
#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #f5f5f5;
}
</style>
